import React, {useEffect, useState} from 'react'
import {Box, Grid, Typography, Button} from '@mui/material'
import {PowerSettingsNew as PowerSettingsNewIcon} from '@mui/icons-material'
import {useNavigate} from 'react-router-dom'

import useWidth from '../../../util/useWidth'
import ClockDatetime1 from '../../../components/clock/clock-datetime-1'
import DisplayNumericImg1 from '../../../components/display/display-numeric-img-1'
import DownloadButton1 from '../../../components/download/downloadButton-1/download-button-1'
import GaugeFixed1 from '../../../components/gauge/gauge-fixed-1'
import {getDataSession, closeSession} from '../../../services/auth/session'

const classes = {
  root: {
    width: '100%',
    height: '100vh',
  },
  title: {
    fontFamily: 'Arial',
    color: 'dedicated.c15',
  },
  titleLogo: {
    height: '20vh',
    marginTop: '8px',
    marginRight: '8px',
    marginLeft: '8px',
  },
  colorControlBottom: {
    color: 'dedicated.c15',
  },
}

const ControlBottom = (props) => {
  const onClick = props.handleClickClose

  const handleClickClose = () => {
    onClick()
  }

  return (
    <Grid
      container
      item
      lg={12}
      md={12}
      sm={12}
      xs={12}
      direction={'row'}
      justifyContent={'center'}
      alignItems={'center'}
    >
      <Grid
        container
        item
        lg={6}
        md={6}
        sm={6}
        xs={6}
        direction={'row'}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <ClockDatetime1 />
      </Grid>
      <Grid
        container
        item
        lg={6}
        md={6}
        sm={6}
        xs={6}
        direction={'row'}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Button onClick={handleClickClose}>
          <Grid
            container
            direction={'row'}
            justifyContent={'center'}
            alignItems={'center'}
          >
            <Grid
              container
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              direction={'row'}
              justifyContent={'center'}
              alignItems={'center'}
            >
              <PowerSettingsNewIcon sx={classes.colorControlBottom} />
            </Grid>
            <Grid
              container
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              direction={'row'}
              justifyContent={'center'}
              alignItems={'center'}
              sx={classes.colorControlBottom}
            >
              <Typography variant={'string'} sx={{textTransform: 'capitalize'}}>
                Cerrar Sesión
              </Typography>
            </Grid>
          </Grid>
        </Button>
      </Grid>
    </Grid>
  )
}

const EnergiaRecuperadaView = (props) => {
  const width = useWidth()
  const navigate = useNavigate()

  const [constructorHasRun, setConstructorHasRun] = useState(false)
  const [session, setSession] = useState(true)

  const [widthMiddleBox, setWidthMiddleBox] = useState('5%')
  const [widthMiddleBox2, setWidthMiddleBox2] = useState('5%')
  const [widthLeftBox, setWidthLeftBox] = useState('95%')
  const [widthLeftBox2, setWidthLeftBox2] = useState('90%')
  const [heightTopBox, setHeightTopBox] = useState('45%')
  const [heightBottomBox, setHeightBottomBox] = useState('45%')
  const [widthBottomBox, setWidthBottomBox] = useState('50%')

  useEffect(() => {
    switch (width) {
      case 'xl':
        setWidthMiddleBox('3%')
        setWidthMiddleBox2('6%')
        setWidthBottomBox('97%')
        setWidthLeftBox('97%')
        setWidthLeftBox2('94%')
        setHeightTopBox('95%')
        setHeightBottomBox('80%')
        break
      case 'lg':
        setWidthMiddleBox('3%')
        setWidthMiddleBox2('6%')
        setWidthBottomBox('97%')
        setWidthLeftBox('97%')
        setWidthLeftBox2('94%')
        setHeightTopBox('90%')
        setHeightBottomBox('80%')
        break
      case 'md':
        setWidthMiddleBox('7%')
        setWidthMiddleBox2('7%')
        setWidthBottomBox('93%')
        setWidthLeftBox('93%')
        setWidthLeftBox2('93%')
        setHeightTopBox('45%')
        setHeightBottomBox('40%')
        break
      case 'sm':
        setWidthMiddleBox('7%')
        setWidthMiddleBox2('7%')
        setWidthBottomBox('93%')
        setWidthLeftBox('93%')
        setWidthLeftBox2('93%')
        setHeightTopBox('45%')
        setHeightBottomBox('40%')
        break
      case 'xs':
        setWidthMiddleBox('9%')
        setWidthMiddleBox2('9%')
        setWidthBottomBox('91%')
        setWidthLeftBox('91%')
        setWidthLeftBox2('91%')
        setHeightTopBox('45%')
        setHeightBottomBox('40%')
        break
      default:
        setWidthMiddleBox('5%')
        setWidthMiddleBox2('5%')
        setWidthBottomBox('95%')
        setWidthLeftBox('90%')
        setWidthLeftBox2('90%')
        setHeightTopBox('45%')
        setHeightBottomBox('40%')
        break
    }
  }, [
    widthMiddleBox,
    widthLeftBox,
    heightTopBox,
    heightBottomBox,
    widthMiddleBox2,
    widthBottomBox,
    width,
  ])
  useEffect(() => {
    if (!session) {
      navigate('/view/sign-in')
    }
  }, [session, navigate])

  const validSession = () => {
    let getData = getDataSession()
    if (!getData.get) {
      setSession(false)
    }
  }

  const handleClickClose = () => {
    closeSession()
    setSession(false)
  }

  const handleClickNavNext = () => {
    navigate('/view/flows')
  }

  const constructor = () => {
    if (constructorHasRun) return
    // ------------
    validSession()

    // ------------
    setConstructorHasRun(true)
  }

  constructor()

  return (
    <Box sx={classes.root}>
      <Grid
        container
        direction={'row'}
        justifyContent={'center'}
        alignItems={'flex-start'}
      >
        {/* Container Left - Title */}
        <Grid
          container
          item
          xl={3}
          lg={3}
          md={4}
          sm={4}
          xs={12}
          direction={'row'}
          justifyContent={'flex-start'}
          sx={{
            ...(width === 'xs'
              ? {height: '22vh'}
              : width === 'sm'
              ? {height: '182vh'}
              : width === 'md'
              ? {height: '182vh'}
              : {height: '100vh'}),
            backgroundColor: 'dedicated.c9',
          }}
        >
          {/* Logo - Img */}
          <Grid
            container
            item
            xl={12}
            lg={12}
            md={12}
            sm={12}
            xs={5}
            direction={'row'}
            justifyContent={width === 'xs' ? 'flex-start' : 'center'}
            alignItems={width === 'xs' ? 'center' : 'flex-start'}
            sx={classes.titleLogo}
          >
            <Box>
              <img
                alt='logo_thermal'
                maxwidth='100px'
                height={width === 'xs' ? '63px' : '100px'}
                src='/images/Thermal_Esco.png'
              />
            </Box>
            <Box>
              <img
                alt='logo_thermal'
                maxwidth='100px'
                height={width === 'xs' ? '63px' : '100px'}
                src='/images/Aconcagua_Foods.png'
              />
            </Box>
          </Grid>
          {/* Title */}
          <Grid
            container
            item
            xl={12}
            lg={12}
            md={12}
            sm={12}
            xs={6}
            direction={'row'}
            justifyContent={width === 'xs' ? 'flex-start' : 'center'}
            alignItems={'center'}
            sx={{
              ...(width === 'xs'
                ? {height: '20vh', marginTop: '8px', marginBottom: '8px'}
                : {height: '70vh', marginRight: '8px', marginLeft: '8px'}),
            }}
          >
            <Box
              sx={{
                ...(width === 'xs'
                  ? {
                      marginLeft: '8px',
                      paddingLeft: '8px',
                      paddingRight: '8px',
                    }
                  : {marginLeft: '30px', paddingLeft: '20px', paddingRight: '10px'}),
                borderLeft: '5px solid #ffffff',
              }}
            >
              <Typography variant={width === 'xs' ? 'body2' : 'body1'} sx={classes.title}>
                SISTEMA DE RECUPERACIÓN DE CALOR DE PURGAS <br />
                <strong>CALDERAS ACONCAGUA FOODS</strong>
              </Typography>
            </Box>
          </Grid>
          {/* Controls */}
          <Grid
            container
            item
            xl={12}
            lg={12}
            md={12}
            sm={12}
            xs={12}
            direction={'row'}
            justifyContent={width === 'xs' ? 'flex-end' : 'center'}
            alignItems='flex-end'
            sx={{
              ...(width === 'xs'
                ? {
                    display: 'none',
                  }
                : {
                    display: 'flex',
                    marginRight: '8px',
                    marginLeft: '8px',
                  }),
            }}
          >
            <ControlBottom handleClickClose={handleClickClose} />
          </Grid>
        </Grid>
        {/* Container Right - Display */}
        <Grid
          container
          item
          xl={9}
          lg={9}
          md={8}
          sm={8}
          xs={12}
          direction='row'
          justifyContent='flex-start'
          alignItems='flex-start'
          sx={{
            ...(width === 'xs'
              ? {
                  height: '239vh',
                }
              : width === 'sm'
              ? {
                  height: '150vh',
                }
              : width === 'md'
              ? {
                  height: '150vh',
                }
              : {
                  height: '100vh',
                }),
          }}
        >
          {/* Container 1 */}
          <Grid
            container
            item
            xl={12}
            lg={12}
            md={12}
            sm={12}
            xs={12}
            direction='row'
            justifyContent='flex-start'
            alignItems='flex-start'
            sx={{
              ...(width === 'xs'
                ? {height: '10vh'}
                : width === 'sm'
                ? {height: '5vh'}
                : width === 'md'
                ? {height: '5vh'}
                : {height: '7vh'}),
              width: '100%',
            }}
          >
            {/* Left */}
            <Grid
              item
              container
              direction='row'
              justifyContent='center'
              alignItems='center'
              sx={{
                ...(width === 'xs'
                  ? {height: '10vh'}
                  : width === 'sm'
                  ? {height: '7vh'}
                  : width === 'md'
                  ? {height: '7vh'}
                  : {height: '9vh'}),
                width: widthMiddleBox,
                backgroundColor: 'dedicated.c10',
              }}
            >
              {''}
            </Grid>
            {/* Rigth */}
            <Grid
              container
              item
              direction='row'
              justifyContent='flex-start'
              alignItems='center'
              sx={{
                ...(width === 'xs'
                  ? {height: '10vh'}
                  : width === 'sm'
                  ? {height: '7vh'}
                  : width === 'md'
                  ? {height: '7vh'}
                  : {height: '9vh'}),
                width: widthLeftBox,
                paddingLeft: '10px',
              }}
            >
              <Typography variant={'h6'}>
                <strong>ENERGÍA RECUPERADA Y GNL AHORRADO</strong>
              </Typography>
            </Grid>
          </Grid>
          {/* Container 2 */}
          <Grid
            container
            item
            xl={6}
            lg={6}
            md={12}
            sm={12}
            xs={12}
            direction='row'
            justifyContent='flex-start'
            alignItems='flex-start'
            sx={{
              ...(width === 'xs'
                ? {height: '110vh'}
                : width === 'sm'
                ? {height: '84vh'}
                : width === 'md'
                ? {height: '84vh'}
                : {height: '84vh'}),
              width: '100%',
            }}
          >
            {/* Top - 2.1 */}
            <Grid
              container
              item
              xl={12}
              lg={12}
              md={12}
              sm={12}
              xs={12}
              direction='row'
              justifyContent='flex-start'
              alignItems='flex-start'
              sx={{
                ...(width === 'xs'
                  ? {height: '55vh'}
                  : width === 'sm'
                  ? {height: '42vh'}
                  : width === 'md'
                  ? {height: '42vh'}
                  : {height: '42vh'}),
                width: '100%',
              }}
            >
              {/* Left */}
              <Grid
                item
                container
                direction='row'
                justifyContent='center'
                alignItems='center'
                sx={{
                  ...(width === 'xs'
                    ? {height: '55vh'}
                    : width === 'sm'
                    ? {height: '42vh'}
                    : width === 'md'
                    ? {height: '42vh'}
                    : {height: '42vh'}),
                  width: widthMiddleBox2,
                  backgroundColor: 'dedicated.c10',
                }}
              >
                <Typography
                  variant={'subtitle1'}
                  sx={{
                    transform: 'rotate(270deg)',
                    whiteSpace: 'nowrap',
                    color: 'dedicated.c15',
                  }}
                >
                  MAKE UP
                </Typography>
              </Grid>
              {/* Rigth */}
              {/* Content - Gauge 1 */}
              <Grid
                container
                item
                direction='column'
                justifyContent='center'
                alignItems='flex-start'
                sx={{
                  width: widthLeftBox2,
                  paddingTop: '10px',
                  paddingBottom: '10px',
                  paddingLeft: '10px',
                  paddingRight: '10px',
                }}
              >
                <Grid item>
                  <GaugeFixed1
                    backgroundImg='/images/energia_recuperada_1.png'
                    centerImg='/images/icono_energia_verde.png'
                    minRange='0'
                    maxRange='2000'
                    title='Energía recuperada instantánea'
                    unit='KW'
                    alignVertival={width === 'xs' ? true : false}
                    event={'datadevice/770917808/dAF126AtpT/gl'}
                    variable={'vPotT6E3xl'}
                  />
                </Grid>
                <Grid
                  item
                  sx={{
                    paddingLeft: '30px',
                    paddingRight: '20px',
                    ...(width === 'xs'
                      ? {
                          paddingLeft: '20px',
                          paddingTop: '30px',
                        }
                      : {
                          paddingLeft: '30px',
                          paddingTop: '17px',
                        }),
                  }}
                >
                  <DisplayNumericImg1
                    iconImg={'icon-energia-recuperada'}
                    title={'Energía total recuperada'}
                    unit={'KWh'}
                    event={'datadevice/770917808/dAF126AtpT/gl'}
                    variable={'vEnr9Zv44U'}
                  />
                </Grid>
              </Grid>
            </Grid>
            {/* Bottom - 2.2 */}
            <Grid
              container
              item
              xl={12}
              lg={12}
              md={12}
              sm={12}
              xs={12}
              direction='row'
              justifyContent='flex-start'
              alignItems='flex-start'
              sx={{
                ...(width === 'xs'
                  ? {height: '55vh'}
                  : width === 'sm'
                  ? {height: '42vh'}
                  : width === 'md'
                  ? {height: '42vh'}
                  : {height: '42vh'}),
                width: '100%',
              }}
            >
              {/* Left */}
              <Grid
                item
                container
                direction='row'
                justifyContent='center'
                alignItems='center'
                sx={{
                  ...(width === 'xs'
                    ? {height: '55vh'}
                    : width === 'sm'
                    ? {height: '42vh'}
                    : width === 'md'
                    ? {height: '42vh'}
                    : {height: '42vh'}),
                  width: widthMiddleBox2,
                  backgroundColor: 'dedicated.c8',
                }}
              >
                <Typography
                  variant={'subtitle1'}
                  sx={{
                    transform: 'rotate(270deg)',
                    whiteSpace: 'nowrap',
                    color: 'dedicated.c15',
                  }}
                >
                  VAPOR FLASH
                </Typography>
              </Grid>
              {/* Rigth */}
              {/* Content - Gauge 2 */}
              <Grid
                container
                item
                direction='column'
                justifyContent='center'
                alignItems='flex-start'
                sx={{
                  width: widthLeftBox2,
                  paddingTop: '10px',
                  paddingBottom: '10px',
                  paddingLeft: '10px',
                  paddingRight: '10px',
                }}
              >
                <Grid item>
                  <GaugeFixed1
                    backgroundImg='/images/energia_recuperada_1.png'
                    centerImg='/images/icono_nube.png'
                    minRange='0'
                    maxRange='2000'
                    title='Energía recuperada instantánea'
                    unit='KW'
                    alignVertival={width === 'xs' ? true : false}
                    event={'datadevice/770917808/dAF126AtpT/gl'}
                    variable={'vVfi48mI5e'}
                  />
                </Grid>
                <Grid
                  item
                  sx={{
                    paddingLeft: '30px',
                    paddingRight: '20px',
                    ...(width === 'xs'
                      ? {
                          paddingLeft: '20px',
                          paddingTop: '30px',
                        }
                      : {
                          paddingLeft: '30px',
                          paddingTop: '17px',
                        }),
                  }}
                >
                  <DisplayNumericImg1
                    iconImg={'icon-energia-verde'}
                    title={'Energía total ahorrada'}
                    unit={'KWh'}
                    event={'datadevice/770917808/dAF126AtpT/gl'}
                    variable={'vVfa6aM2V1'}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {/* Container 3 */}
          <Grid
            container
            item
            xl={6}
            lg={6}
            md={12}
            sm={12}
            xs={12}
            direction='row'
            justifyContent='flex-start'
            alignItems='flex-start'
            sx={{
              ...(width === 'xs'
                ? {height: '110vh'}
                : width === 'sm'
                ? {height: '84vh'}
                : width === 'md'
                ? {height: '84vh'}
                : {height: '84vh'}),
              width: '100%',
            }}
          >
            {/* Top - 3.1 */}
            <Grid
              container
              item
              xl={12}
              lg={12}
              md={12}
              sm={12}
              xs={12}
              direction='row'
              justifyContent='flex-start'
              alignItems='flex-start'
              sx={{
                ...(width === 'xs'
                  ? {height: '55vh'}
                  : width === 'sm'
                  ? {height: '42vh'}
                  : width === 'md'
                  ? {height: '42vh'}
                  : {height: '42vh'}),
                width: '100%',
              }}
            >
              {/* Left */}
              <Grid
                item
                container
                direction='row'
                justifyContent='center'
                alignItems='center'
                sx={{
                  ...(width === 'xs'
                    ? {height: '55vh', backgroundColor: 'dedicated.c10'}
                    : width === 'sm'
                    ? {height: '42vh', backgroundColor: 'dedicated.c10'}
                    : width === 'md'
                    ? {height: '42vh', backgroundColor: 'dedicated.c10'}
                    : {height: '42vh', backgroundColor: 'dedicated.c8'}),
                  width: widthMiddleBox2,
                }}
              >
                <Typography
                  variant={'subtitle1'}
                  sx={{
                    transform: 'rotate(270deg)',
                    whiteSpace: 'nowrap',
                    color: 'dedicated.c15',
                  }}
                >
                  ENERGÍA TOTAL
                </Typography>
              </Grid>
              {/* Rigth */}
              {/* Content - Gauge 3 */}
              <Grid
                container
                item
                direction='column'
                justifyContent='center'
                alignItems='flex-start'
                sx={{
                  width: widthLeftBox2,
                  paddingTop: '10px',
                  paddingBottom: '10px',
                  paddingLeft: '10px',
                  paddingRight: '10px',
                }}
              >
                <Grid item>
                  <GaugeFixed1
                    backgroundImg='/images/gas_natural_1.png'
                    centerImg='/images/Icono_energia.png'
                    minRange='0'
                    maxRange='4000'
                    title='Energía recuperada instantánea'
                    unit='KW'
                    alignVertival={width === 'xs' ? true : false}
                    event={'datadevice/770917808/dAF126AtpT/gl'}
                    variable={'vCtiQO8n40'}
                  />
                </Grid>
                <Grid
                  item
                  sx={{
                    paddingLeft: '30px',
                    paddingRight: '20px',
                    ...(width === 'xs'
                      ? {
                          paddingLeft: '20px',
                          paddingTop: '30px',
                        }
                      : {
                          paddingLeft: '30px',
                          paddingTop: '17px',
                        }),
                  }}
                >
                  <DisplayNumericImg1
                    iconImg={'icon-energia'}
                    title={'Energía total ahorrada'}
                    unit={'KWh'}
                    event={'datadevice/770917808/dAF126AtpT/gl'}
                    variable={'vCta23GEr4'}
                  />
                </Grid>
              </Grid>
            </Grid>
            {/* Bottom - 3.2 */}
            <Grid
              container
              item
              xl={12}
              lg={12}
              md={12}
              sm={12}
              xs={12}
              direction='row'
              justifyContent='flex-start'
              alignItems='flex-start'
              sx={{
                ...(width === 'xs'
                  ? {height: '55vh'}
                  : width === 'sm'
                  ? {height: '42vh'}
                  : width === 'md'
                  ? {height: '42vh'}
                  : {height: '42vh'}),
                width: '100%',
              }}
            >
              {/* Left */}
              <Grid
                item
                container
                direction='row'
                justifyContent='center'
                alignItems='center'
                sx={{
                  ...(width === 'xs'
                    ? {height: '55vh', backgroundColor: 'dedicated.c8'}
                    : width === 'sm'
                    ? {height: '42vh', backgroundColor: 'dedicated.c8'}
                    : width === 'md'
                    ? {height: '42vh', backgroundColor: 'dedicated.c8'}
                    : {height: '42vh', backgroundColor: 'dedicated.c10'}),
                  width: widthMiddleBox2,
                }}
              >
                <Typography
                  variant={'subtitle1'}
                  sx={{
                    transform: 'rotate(270deg)',
                    whiteSpace: 'nowrap',
                    color: 'dedicated.c15',
                  }}
                >
                  GNL
                </Typography>
              </Grid>
              {/* Rigth */}
              {/* Content - Gauge 4 */}
              <Grid
                container
                item
                direction='column'
                justifyContent='center'
                alignItems='flex-start'
                sx={{
                  width: widthLeftBox2,
                  paddingTop: '10px',
                  paddingBottom: '10px',
                  paddingLeft: '10px',
                  paddingRight: '10px',
                }}
              >
                <Grid item>
                  <GaugeFixed1
                    backgroundImg='/images/gas_natural_2.png'
                    centerImg='/images/Icono_gas.png'
                    minRange='0'
                    maxRange='500'
                    title='Gas natural recuperado instantáneo'
                    unit='Nm3/h'
                    alignVertival={width === 'xs' ? true : false}
                    event={'datadevice/770917808/dAF126AtpT/gl'}
                    variable={'vGniFo74F0'}
                  />
                </Grid>
                <Grid
                  item
                  sx={{
                    paddingLeft: '30px',
                    paddingRight: '20px',
                    ...(width === 'xs'
                      ? {
                          paddingLeft: '20px',
                          paddingTop: '30px',
                        }
                      : {
                          paddingLeft: '30px',
                          paddingTop: '17px',
                        }),
                  }}
                >
                  <DisplayNumericImg1
                    iconImg={'icon-gas'}
                    title={'Gas natutal total ahorrado'}
                    unit={'Nm3'}
                    event={'datadevice/770917808/dAF126AtpT/gl'}
                    variable={'vGnaw679Lv'}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {/* Container 4 */}
          <Grid
            container
            item
            xl={12}
            lg={12}
            md={12}
            sm={12}
            xs={12}
            direction='row'
            justifyContent='flex-start'
            alignItems='flex-start'
            sx={{
              ...(width === 'xs'
                ? {height: '9vh'}
                : width === 'sm'
                ? {height: '9h'}
                : width === 'md'
                ? {height: '9h'}
                : {height: '9vh'}),
              width: '100%',
            }}
          >
            {/* Left */}
            <Grid
              item
              container
              direction='row'
              justifyContent='center'
              alignItems='center'
              sx={{
                ...(width === 'xs'
                  ? {height: '9vh'}
                  : width === 'sm'
                  ? {height: '9vh'}
                  : width === 'md'
                  ? {height: '9vh'}
                  : {height: '9vh'}),
                width: widthMiddleBox,
                backgroundColor: 'dedicated.c8',
              }}
            ></Grid>
            {/* Rigth / Download - Navegate*/}
            <Grid
              container
              item
              sx={{
                width: widthBottomBox,
              }}
            >
              <Grid
                container
                item
                xl={6}
                lg={6}
                md={6}
                sm={6}
                xs={6}
                direction={'row'}
                justifyContent={'flex-start'}
                alignItems={'center'}
              >
                <DownloadButton1 />
              </Grid>
              <Grid
                container
                item
                lg={6}
                md={6}
                sm={6}
                xs={6}
                direction={'row'}
                justifyContent={'flex-end'}
                alignItems={'center'}
              >
                <Button onClick={handleClickNavNext}>
                  <img
                    alt='logo_nav'
                    width={width === 'xs' ? '35px' : '45px'}
                    height={width === 'xs' ? '35px' : '45px'}
                    style={{transform: 'rotate(180deg)'}}
                    src={'/images/Flecha_avanza.png'}
                  />
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {/* Container Bottom (Only XS) - Clock and Logout */}
        <Grid
          container
          item
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
          direction={'row'}
          justifyContent={'center'}
          sx={{
            ...(width === 'xs'
              ? {
                  display: 'flex',
                }
              : {display: 'none'}),
            height: '10vh',
            backgroundColor: 'dedicated.c9',
          }}
        >
          <ControlBottom handleClickClose={handleClickClose} />
        </Grid>
      </Grid>
    </Box>
  )
}

export default EnergiaRecuperadaView
